import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppGlobals } from 'src/app/app.globals';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      tap<HttpEvent<any>>({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              AppGlobals.LoggedIn = false;
              AppGlobals.GlobalLoaderVisible = false;
            }
          }
        },
      })
    );
  }
}
